/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';

/**
 * This simple component allows the DatePicker to render as a dropdown
 */
export default class Dropdown extends React.Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    onClickOutside: PropTypes.func,
    children: PropTypes.node
  };

  constructor(props) {
    super(props);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
  }

  handleDocumentClick(event) {
    const { onClickOutside, isOpen } = this.props;
    const el = this.container;
    if (isOpen && !el.contains(event.target)) onClickOutside(event);
  }

  componentDidMount() {
    document.addEventListener('click', this.handleDocumentClick, true);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleDocumentClick, true);
  }

  render() {
    const { children, isOpen, onClickOutside } = this.props;
    if (!isOpen) return null;

    return <div ref={ref => (this.container = ref)}>{children}</div>;
  }
}
